'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewport = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $viewportMap = _require.$viewportMap; // =============================================================================
// VIEWPORT (Settings)
// =============================================================================


var viewport = exports.viewport = (0, _dictionary2.default)($viewportMap, 'Unknown viewport used in viewport function');
//# sourceMappingURL=viewport.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/settings/viewport.js